// export const Mutation_setBodyBgColor = "setBodyBgColor"
export const Mutation_addNavLink = "addNavLink"
export const Mutation_addOutsiteLink = "addOutsiteLink"